import Vue from 'vue';
import Store from '../../lib/stores/store';
import Instance from './instance.html';
import BookingConfirmation from './booking-confirmation';

if (document.getElementById('bookingConfirmation')) {
	const vue = new Vue({
		el: '#bookingConfirmation',
		store: Store,
		template: Instance,
		components: {
			BookingConfirmation,
		},
	});
}
